import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sid) { nav("/admin/login"); return; }
      try {
        await axios.post(`${API}/auth/session`, {}, {
          headers: { "X-Session-ID": sid },
          withCredentials: true,
        });
        window.history.replaceState(null, "", "/admin");
        await refresh();
        nav("/admin");
      } catch (e) {
        toast.error(e.response?.data?.detail || "Google sign-in failed.");
        nav("/admin/login");
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-[var(--apex-primary)]">
      <Loader2 className="animate-spin text-white" size={32} />
    </div>
  );
}
